module.exports = __webpack_public_path__ + "static/media/infographic_data.116345a0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/infographic_data.png
 ** module id = 456
 ** module chunks = 0
 **/